var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStackFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0412 5.25001L10.6422 5.61066C10.7606 5.68171 10.799 5.83526 10.728 5.95366C10.7068 5.98886 10.6774 6.01831 10.6422 6.03941L5.99946 8.82501L1.35677 6.03941C1.23837 5.96836 1.19998 5.81481 1.27102 5.69641C1.29213 5.66121 1.32158 5.63176 1.35677 5.61066L1.95781 5.25001L5.99946 7.67501L10.0412 5.25001ZM10.0412 7.60001L10.6422 7.96066C10.7606 8.03171 10.799 8.18526 10.728 8.30366C10.7068 8.33886 10.6774 8.36831 10.6422 8.38941L6.25671 11.0207C6.09836 11.1157 5.90056 11.1157 5.74221 11.0207L1.35677 8.38941C1.23837 8.31836 1.19998 8.16481 1.27102 8.04641C1.29213 8.01121 1.32158 7.98176 1.35677 7.96066L1.95781 7.60001L5.99946 10.025L10.0412 7.60001ZM6.25671 0.65438L10.6422 3.28566C10.7606 3.35669 10.799 3.51026 10.728 3.62865C10.7068 3.66385 10.6774 3.69329 10.6422 3.7144L5.99946 6.50001L1.35677 3.7144C1.23837 3.64337 1.19998 3.4898 1.27102 3.37141C1.29213 3.33622 1.32158 3.30677 1.35677 3.28566L5.74221 0.65438C5.90056 0.55938 6.09836 0.55938 6.25671 0.65438Z",
    fill: "#182534"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStackFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stack-fill.398865c0.svg";
export { ForwardRef as ReactComponent };